export const accountGenericError = 'Unable to create account holder';
export const accountExistError = 'Account holder already exists';
